import { call, put, select } from 'redux-saga/effects';

import { takeLatest } from '../../../utils/reduxSaga';
import { actions as sagaActions, GET_SETTINGS } from './types';
import { actions as reduxActions } from '../reducers';
import { actions as loaderReducActions } from '../../../partials/loader/reducers';
import { selectors as builderGetters } from '../../../../_metronic/ducks/builder';
import { URLS } from '../../../consts/endpoints';
import urlCreator from '../../../utils/urlCreator';
import { getData } from '../../../utils/http';
import mapSettingsToStore from './mapSettingsToStore';
import mapSettings from '../../loadingScreen/actions/mapSettings';
import { isArray, isDefined, isUndefined } from '../../../utils/isDefined';
import { translate } from '../../../i18n/I18nProvider';

const QUERY_PARAMS = {
  include: ['clients', 'client']
};

export function fetchSettings(partnerId) {
  return {
    type: sagaActions[GET_SETTINGS],
    partnerId
  };
}

export function* getSettings({ partnerId }) {
  const defaultSettings = yield select(builderGetters.getDefaultSettings);

  yield put(loaderReducActions.startLinearLoader());
  const isNewPartner = isUndefined(partnerId);
  try {
    const { data } = !isNewPartner
      ? yield call(
          getData,
          urlCreator(`${URLS.PARTNERS}/${partnerId}.json`, QUERY_PARAMS)
        )
      : { data: {} };

    const updatedSettings = yield call(
      mapSettings,
      isNewPartner ? defaultSettings : data.settings.frontend_settings,
      defaultSettings
    );

    const clientsOptions = isArray(data.clients)
      ? [
          { label: translate('APP_SETTINGS.NO_CLIENT_SELECTED'), value: '' },
          ...data.clients.map(client => ({
            label: client.name,
            value: client.id
          }))
        ]
      : [];

    const settings = {
      ...data.settings
    };

    yield put(
      reduxActions.setSettings(
        mapSettingsToStore({
          ...settings,
          frontend_settings: { ...updatedSettings },
          selectedClient: data.client ? data.client.id : null
        }),
        partnerId,
        isNewPartner ? '' : data.name,
        clientsOptions
      )
    );
  } catch {
    reduxActions.setSettings({});
  }
  yield put(loaderReducActions.stopLinearLoader());
}

function* watchGetAppSettings() {
  yield takeLatest(sagaActions[GET_SETTINGS], getSettings);
}

export default watchGetAppSettings();
